// extracted by mini-css-extract-plugin
module.exports = {"sub":"CustCard_sub__3Xjf_","card":"CustCard_card__2FIx4"};